class QuickBuyContent extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)
    this.toggleVariantSelect = this.toggleVariantSelect.bind(this)

    if (this.els?.button?.exists === true) {
      this.els.button.elements.forEach((item) => {
        this.listeners.add(item, `click`, this.handleTrigger)
      })
    }

    if (this.els.variantButton?.exists === true) {
      this.listeners.add(
        this.els.variantButton.element,
        'click',
        this.toggleVariantSelect,
      )
    }

    if (this.els?.variantOptionButton?.exists === true) {
      this.els.variantOptionButton.elements.forEach((item) => {
        this.listeners.add(
          item,
          `click`,
          this.handleVariantSelection.bind(this),
        )
      })
    }
  }

  toggleVariantSelect (event) {
    const optionsEl = this.els.variantOptions.element
    const currentState = optionsEl.getAttribute('aria-expanded') === 'true'
    optionsEl.setAttribute('aria-expanded', !currentState)
  }

  handleVariantSelection (event) {
    const newText = event.currentTarget.dataset.variantTitle
    const textElement = this.els.variantSelection.element

    textElement.innerHTML = newText

    const optionsEl = this.els.variantOptions.element
    optionsEl.setAttribute('aria-expanded', 'false')

    const currentButton = event.currentTarget
    const newVariantID = currentButton.dataset.id
    const available = currentButton.dataset.available === 'true'
    const endOfLife = currentButton.dataset.endOfLife === 'true'
    const showBis = available || endOfLife

    currentButton.setAttribute('aria-pressed', 'true')
    this.els.formID.element.value = newVariantID
    this.els.submit.element.disabled = !available
    this.els.submitText.element.innerHTML = available
      ? window.theme.strings.addToCart
      : window.theme.strings.soldOut

    this.els.bis.element.setAttribute('aria-hidden', showBis)
    this.els.submit.element.setAttribute('aria-hidden', !showBis)

    const currentProductUrl =
      this.els.bis.element.getAttribute('data-product-url')
    const tempUrl = new URL(currentProductUrl, window.location.origin)
    tempUrl.searchParams.set('variant', newVariantID)
    this.els.bis.element.setAttribute(
      'data-product-url',
      `${tempUrl.pathname}${tempUrl.search}`,
    )
  }

  handleTrigger (event) {
    this.removeActive()
  }

  removeActive () {
    this.els.button.elements.forEach((buttonEl) => {
      buttonEl.setAttribute('aria-pressed', 'false')
    })
  }
}

if (!customElements.get('quick-buy-content')) {
  customElements.define('quick-buy-content', QuickBuyContent)
}
